
import { Link } from 'react-router-dom';

export default function Footer() {
  const quickLinks = [
    { name: 'Home', path: '/' },
    { name: 'About Us', path: '/about' },
    { name: 'Our Services', path: '/services' },
    { name: 'Why Choose Us', path: '/why-choose-us' },
    { name: 'Core Values', path: '/core-values' },
    { name: 'Market Segment', path: '/market-segment' },
    { name: 'Sustainability', path: '/sustainability' },
    { name: 'Our Team', path: '/team' },
    { name: 'FAQ', path: '/faq' },
    { name: 'Blog', path: '/blog' },
    { name: 'Contact', path: '/contact' }
  ];

  const services = [
    'Cocoa Sourcing & Export',
    'Traceability & Certification',
    'Bonded Warehousing',
    'Farmer Engagement'
  ];

  return (
    <footer className="bg-green-900 text-white">
      <div className="container mx-auto px-4 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {/* Company Info */}
          <div>
            <div className="flex items-center mb-6">
              <img 
                src="https://static.readdy.ai/image/ee7d0f3d5dd5d8644a11a0562535fbc0/6a63cd5bb8341552887eb0ec3e72e3a0.png" 
                alt="Olatunde International Limited" 
                className="h-10 w-auto brightness-0 invert"
              />
            </div>
            <p className="text-green-200 mb-4 leading-relaxed">
              Empowering the cocoa value chain for a sustainable future since 1994. 
              Premier Nigerian cocoa export company committed to ethical sourcing and farmer prosperity.
            </p>
            <div className="flex space-x-4">
              <div className="w-8 h-8 flex items-center justify-center">
                <i className="ri-facebook-fill text-green-200 hover:text-white cursor-pointer transition-colors"></i>
              </div>
              <div className="w-8 h-8 flex items-center justify-center">
                <i className="ri-twitter-fill text-green-200 hover:text-white cursor-pointer transition-colors"></i>
              </div>
              <div className="w-8 h-8 flex items-center justify-center">
                <i className="ri-linkedin-fill text-green-200 hover:text-white cursor-pointer transition-colors"></i>
              </div>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-lg font-semibold mb-6">Quick Links</h4>
            <ul className="space-y-3">
              {quickLinks.map((link) => (
                <li key={link.path}>
                  <Link 
                    to={link.path} 
                    className="text-green-200 hover:text-white cursor-pointer transition-colors"
                  >
                    {link.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Services */}
          <div>
            <h4 className="text-lg font-semibold mb-6">Our Services</h4>
            <ul className="space-y-3">
              {services.map((service) => (
                <li key={service} className="text-green-200">
                  {service}
                </li>
              ))}
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="text-lg font-semibold mb-6">Contact Us</h4>
            <div className="space-y-4">
              <div className="flex items-start space-x-3">
                <div className="w-5 h-5 flex items-center justify-center mt-1">
                  <i className="ri-map-pin-fill text-amber-500"></i>
                </div>
                <div>
                  <p className="text-green-200">
                    14, Omoniyi Street, Lafe Inn Way<br />
                    Akure, Ondo State<br />
                    Nigeria
                  </p>
                </div>
              </div>
              <div className="flex items-center space-x-3">
                <div className="w-5 h-5 flex items-center justify-center">
                  <i className="ri-phone-fill text-amber-500"></i>
                </div>
                <p className="text-green-200">+234 (705) 568 9282</p>
              </div>
              <div className="flex items-center space-x-3">
                <div className="w-5 h-5 flex items-center justify-center">
                  <i className="ri-mail-fill text-amber-500"></i>
                </div>
                <p className="text-green-200">frontdesk@olatundeintl.com</p>
              </div>
              <div className="mt-4">
                <p className="text-green-200 text-sm mb-2">Business Hours:</p>
                <p className="text-green-200 text-sm">Monday – Saturday</p>
                <p className="text-green-200 text-sm">8:00 AM – 6:00 PM WAT</p>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Copyright */}
      <div className="border-t border-green-800">
        <div className="container mx-auto px-4 py-6">
          <div className="flex flex-col md:flex-row justify-between items-center">
            <p className="text-green-200 text-sm">
              © 2024 Olatunde International Limited. All rights reserved.
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
}
